import { useCallback, useState } from 'react';
import { FormField } from 'taboola-ultimate-ui';
import { Input, InputTypes } from 'taboola-ultimate-ui';
import commonStyles from 'modules/campaigns/modules/common-campaign-form/components/commonEditor.module.scss';
import { withIndication } from 'modules/errors';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { validationFunctions, withInputValidations } from 'modules/taboola-common-frontend-modules/validations';

const inputPadding = parseInt(commonStyles.currencyInputLeftPadding);

const percentageInputRegex = value => /^(?!-?$)(?!\.?$)(?!-?\.$)-?(?:\d+|\d*\.\d{1,2})$/.test(String(value));

const InputWithValidations = withInputValidations(withIndication(Input), [
    {
        validationFn: validationFunctions.isFloat,
        messageId: 'validations.error.campaign.bid.modifier.float',
        defaultMessage: 'Percentage must be a number',
    },
    {
        validationFn: percentageInputRegex,
        messageId: 'validations.error.campaign.bid.modifier.digits',
        defaultMessage: 'Percentage can have at most 2 digits after the decimal point',
    },
    {
        validationFn: validationFunctions.range,
        options: { min: -99.99 },
        messageId: 'validations.error.campaign.bid.modifier.below.zero',
        defaultMessage: 'Bid after percentage adjustment cannot be 0 or less than 0',
    },
]);

export const BidPercentModifier = () => {
    const [percent, setPercent] = useState('');
    const { value: bid = '', onChange: onChangeBid } = useFormFieldValue({
        field: 'bid',
    });

    const onChangePercent = useCallback(
        value => {
            setPercent(value);

            if (bid === null || value === 0) {
                return;
            }

            onChangeBid(value);
        },
        [bid, onChangeBid]
    );

    return (
        <FormField inputId="bidModifier">
            <InputWithValidations
                type={InputTypes.NUMBER}
                id="bidModifier"
                onChange={e => onChangePercent(e.target.value)}
                icon="%"
                inputPadding={inputPadding}
                placeholder="00"
                value={percent}
            />
        </FormField>
    );
};
